function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30",
  height: "16",
  width: "16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M25.66 28.64v-1.37H4.34c-.89 0-1.61-.72-1.61-1.61V4.34c0-.89.72-1.61 1.61-1.61h21.32c.89 0 1.61.72 1.61 1.61v21.32c0 .89-.72 1.61-1.61 1.61V30c2.4 0 4.34-1.94 4.34-4.34V4.34C30 1.94 28.06 0 25.66 0H4.34A4.35 4.35 0 000 4.34v21.32C0 28.06 1.94 30 4.34 30h21.32v-1.36",
  fill: "currentColor"
}));